const ShimmerBar = ({ className }: { className?: string }) => (
  <div
    className={`relative overflow-hidden rounded bg-background-light ${className ?? ''}`}
  >
    <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
  </div>
);

const PostSkeletonLoading = () => {
  return (
    <div className="w-full rounded-lg border border-ds-border-subtle bg-background-light p-4">
      {/* Head: avatar + name/username/time */}
      <div className="mb-3 flex items-center gap-2">
        <div className="relative size-9 shrink-0 overflow-hidden rounded-full bg-background-light">
          <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        </div>
        <div className="flex flex-col gap-1.5">
          <ShimmerBar className="h-3 w-28" />
          <div className="flex items-center gap-2">
            <ShimmerBar className="h-2.5 w-20" />
            <ShimmerBar className="h-2.5 w-10" />
          </div>
        </div>
      </div>

      {/* Body: text lines */}
      <div className="mb-3 flex flex-col gap-2">
        <ShimmerBar className="h-3 w-[90%]" />
        <ShimmerBar className="h-3 w-[75%]" />
        <ShimmerBar className="h-3 w-[60%]" />
      </div>

      {/* Actions bar: vote, reply, factiii, views */}
      <div className="flex items-center justify-between border-t border-ds-border-subtle pt-3">
        <div className="flex items-center gap-4">
          {/* Vote arrows + count */}
          <div className="flex items-center gap-1.5">
            <ShimmerBar className="size-4 rounded-sm" />
            <ShimmerBar className="h-3 w-6" />
            <ShimmerBar className="size-4 rounded-sm" />
          </div>
          {/* Reply */}
          <div className="flex items-center gap-1.5">
            <ShimmerBar className="size-4 rounded-sm" />
            <ShimmerBar className="h-3 w-4" />
          </div>
          {/* Factiii */}
          <ShimmerBar className="size-4 rounded-sm" />
        </div>
        {/* Views */}
        <div className="flex items-center gap-1.5">
          <ShimmerBar className="size-4 rounded-sm" />
          <ShimmerBar className="h-3 w-6" />
        </div>
      </div>
    </div>
  );
};

export default PostSkeletonLoading;
